export default __webpack_public_path__ + "static/media/banner.d59d02a6.png";